import { IComponentOptions, IController } from 'angular';
import { IMenuItem } from '../../menu.items';
import './sidebar-item.component.scss';
import { cloneDeep } from 'lodash-es';

class SidebarItemCtrl implements IController {
  item: IMenuItem = {};
  isOpenedClone: boolean;
  isOpened = false;
  showTitle = true;
  counter: any;

  $onInit() {
    this.isOpenedClone = cloneDeep(this.isOpened);
  }

  $onChanges() {
    if (!this.showTitle) {
      this.isOpened = false;
    } else {
      this.isOpened = this.isOpenedClone;
    }
  }

  get parsedCounter() {
    return this.counter < 100 ? `${this.counter}` : '99+';
  }

  toggle(event) {
    this.isOpened = !this.isOpened;
    this.isOpenedClone = cloneDeep(this.isOpened);
    event.stopPropagation();
  }

  isActive(key) {
    if (!this.getCounter(key)) {
      return;
    }
    return this.getCounter(key)['active'] && !this.getCounter(key)['inactive'];
  }

  getCounter(key): any {
    if (!key || !this.getCounter) {
      return null;
    }

    const c = this.getCounter(key);

    if (c > 99) {
      return '99+';
    }

    return c;
  }
}

export const SidebarItemComponent: IComponentOptions = {
  controller: SidebarItemCtrl,
  template: require('./sidebar-item.component.html'),
  bindings: {
    item: '<?',
    isOpened: '<?',
    showTitle: '<?',
    getCounter: '<?'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/dashboard/components/sidebar-item/sidebar-item.component.ts